var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup633(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_633",
    "data-name": "Group 633",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 54.812,
    viewBox: "0 0 55 54.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 55,
    height: 54.812,
    fill: "#fa0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M157.054,11.928a4.933,4.933,0,0,1-4.916-4.864,5.025,5.025,0,0,1,4.885-4.94,5.111,5.111,0,0,1,4.94,4.924,4.934,4.934,0,0,1-4.91,4.88",
    transform: "translate(-129.569 -1.809)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M267.5,83.165a3.7,3.7,0,0,1-3.594,3.736,3.7,3.7,0,0,1-.061-7.4,3.619,3.619,0,0,1,3.655,3.663",
    transform: "translate(-221.596 -67.708)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M67.925,83.275a3.694,3.694,0,0,1-7.387-.065A3.767,3.767,0,0,1,64.306,79.5a3.853,3.853,0,0,1,3.618,3.778",
    transform: "translate(-51.557 -67.703)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M1.533,14.65Q4.6,19.089,7.665,23.527A8.041,8.041,0,0,1,9.127,28.24c-.02,3.953-.029,7.906.007,11.859a19.224,19.224,0,0,0,.186,4.679c.12.471-.175.557-.531.569-.711.023-1.428-.008-2.134.06-1.24.12-1.7.6-1.787,1.836-.037.5-.046.994-.037,1.492H51.444c0-.184-.008-.37-.01-.554-.03-2.394-.44-2.807-2.8-2.822h-.427c-1.345,0-1.33,0-1.137-1.274a9.359,9.359,0,0,0,.065-1.385q.008-7.318,0-14.637a7.456,7.456,0,0,1,1.234-4.246c1.324-1.984,2.719-3.92,4.071-5.886.948-1.378,1.9-2.753,2.8-4.165a1.3,1.3,0,0,0-.42-1.952,1.32,1.32,0,0,0-1.887.383c-.311.389-.6.794-.888,1.2q-2.353,3.373-4.7,6.753A3.153,3.153,0,0,1,44.643,21.6c-1.175.01-2.351.012-3.525,0a2.906,2.906,0,0,1-2.459-1.278c-.8-1.134-1.563-2.3-2.41-3.4a1.367,1.367,0,0,1-.009-1.9c2.148-3.016,4.247-6.067,6.353-9.113.708-1.025,1.421-2.051,2.058-3.12a1.847,1.847,0,0,0-.593-2.45A1.871,1.871,0,0,0,41.564.72a10.322,10.322,0,0,0-.646.85q-3.474,5-6.939,10.007a3.844,3.844,0,0,1-2.7,1.738,26.438,26.438,0,0,1-6.071.058,3.964,3.964,0,0,1-2.973-1.868c-2.312-3.38-4.658-6.735-6.992-10.1C14.269,0,13.191-.362,12.148.367c-1.01.706-1.051,1.813-.119,3.195.04.059.079.119.119.177,2.658,3.833,5.3,7.675,7.985,11.491a1.123,1.123,0,0,1-.009,1.526,29.794,29.794,0,0,0-1.883,2.722,4.142,4.142,0,0,1-4.069,2.159c-4.3-.089-4.3-.03-6.73-3.6-1.324-1.942-2.659-3.876-4.023-5.79a1.39,1.39,0,0,0-2.052-.4,1.435,1.435,0,0,0-.359,2,9.157,9.157,0,0,0,.525.8M33.346,44.666a3.75,3.75,0,0,0,.332-2.079q0-10.19,0-20.38a5.67,5.67,0,0,1,.576-3.049c2.088,3.174,4.782,5.813,4.6,10-.205,4.615-.047,9.245-.047,13.869,0,.285-.007.57.006.853.069,1.478.072,1.478-1.478,1.478-1.174,0-2.347,0-3.521,0-.513,0-.883-.032-.469-.694m-16.029.1a9.366,9.366,0,0,0,.138-2.652c.012-4.515.021-9.03,0-13.545a8.622,8.622,0,0,1,1.611-5.2c.846-1.186,1.661-2.4,2.5-3.59.117-.168.2-.439.441-.412.317.036.283.358.342.587a9.193,9.193,0,0,1,.239,2.326q-.008,5.066,0,10.132,0,5.279,0,10.559a3.277,3.277,0,0,0,.226,1.568c.319.611.131.834-.527.827-1.457-.015-2.915,0-4.373-.008-.382,0-.753-.035-.59-.592",
    transform: "translate(-0.645 0)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M.431,341.565c-.013.022-.028.041-.04.065a3.946,3.946,0,0,0-.1,3.205c.341.941,1.272.871,2.1.87q12.553-.006,25.107,0H52.4a9.484,9.484,0,0,0,1.067-.023,1.5,1.5,0,0,0,1.416-1.364c.225-1.362.151-2.229-.342-2.75Z",
    transform: "translate(0 -290.895)",
    fill: "#fa0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup633);
export default __webpack_public_path__ + "static/media/Group633.f7467e270b18fda6c83d61040afe2f53.svg";
export { ForwardRef as ReactComponent };